import type { Category } from "./Category.js";
import { Locale, type LocalizedString } from "./Locale.js";
import { namesOfEventCategories } from "./namesOfEventCategories.js";

export const namesOfProductCategoriesForMenu = {
	cakes: { [Locale.cs]: "Dorty" },
	desserts: { [Locale.cs]: "Zákusky" },
	minidesserts: { [Locale.cs]: "Minidezerty" },
	...namesOfEventCategories,
	extras: { [Locale.cs]: "Doplňky" },
} satisfies Record<string, LocalizedString>;

export type CategoriesForMenu = Record<keyof typeof namesOfProductCategoriesForMenu, Category>;
